<template>
  <ProjectBaseView>
    <GrupalChat />
  </ProjectBaseView>
</template>

<script>
import GrupalChat from "@/components/project/meetingminute/bottomnavbar/chat/GrupalChat.vue";
import ProjectBaseView from "./ProjectBaseView.vue";

export default {
  name: "ChatView",
  components: {
    ProjectBaseView,
    GrupalChat,
  },
  data() {
    return {
      project: {},
    }
  },
  methods: {
    
  },
  mounted(){
    this.$store.commit('resetMessageCount');
  }
}
</script>

<style scoped>

</style>